/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo} from "react";
import {Mode, Token} from "./Kuromoji";
import UI from "../common/UI";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
    tokens: {
        marginTop: "2rem",
        [UI.media.only("xs")]: {
            overflow: "auto",
            "& table": {
                width: 600
            }
        },
        [UI.media.gte("sm")]: {
            "& table": {
                borderCollapse: "collapse",
                width: "100%"
            }
        },
        "& table": {
            borderCollapse: "collapse"
        },
        "& td, & th": {
            padding: ".5rem",
            borderTop: `1px solid ${UI.colors.lightGrey.toCSS()}`,
            verticalAlign: "middle",
            textAlign: "left"
        }
    }
});

interface KuromojiDemoTokensProps {
    tokens: Token[];
    mode: Mode;
}

function KuromojiDemoTokens({tokens, mode}: KuromojiDemoTokensProps) {
    const classes = useStyles();
    if (tokens.length < 1 || mode === Mode.Viterbi) {
        return null;
    }

    return (
        <div className={classes.tokens}>
            <table>
                <thead>
                    <tr>
                        <th>Surface form</th>
                        <th>Part-of-Speech</th>
                        <th>Base form</th>
                        <th>Reading Pronunciation</th>
                    </tr>
                </thead>
                <tbody>
                    {tokens.map((token, index) => (
                        <tr key={index}>
                            <td>{token.surface}</td>
                            <td>{token.pos}</td>
                            <td>{token.base}</td>
                            <td>{token.reading}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default memo(KuromojiDemoTokens);
